export enum ActionType {
    FETCH_BIO = "fetch_bio",
    FETCH_BIO_SUCCESS = "fetch_bio_success",
    SAVE_BIO = "save_bio",
    SAVE_BIO_SUCCESS = "save_bio_success",
    SAVE_CURRENT_BIO = "save_current_bio",
    UPDATE_BIO = "update_bio",
    UPDATE_BIO_SUCCESS = "update_bio_success",
    BIO_ERROR = "bio_error",

    FETCH_EDUCATIONS = "fetch_educations",
    FETCH_EDUCATIONS_SUCCESS = "fetch_educations_success",
    FORM_UPDATE_EDUCATION = "form_update_education",
    FORM_UPDATE_EDUCATION_SUCCESS = "form_update_education_success",
    UPDATE_EDUCATION = "update_education",
    UPDATE_EDUCATION_SUCCESS = "update_education_success",
    ADD_EDUCATION = "add_education",
    CANCEL_ADD_EDUCATION = "cancel_add_education",
    ADD_EDUCATION_SUCCESS = "add_education_success",
    SWITCH_ADD_EDUCATION = "switch_add_education",
    SAVE_NEW_EDUCATION = "save_new_education",
    SAVE_NEW_EDUCATION_SUCCESS = "save_new_education_success",
    DELETE_EDUCATION = "delete_education",
    DELETE_EDUCATION_SUCCESS = "delete_education_success",
    EDUCATION_ERROR = "education_error",

    FETCH_PROJECTS = "fetch_projects",
    FETCH_PROJECTS_SUCCESS = "fetch_projects_success",
    FORM_UPDATE_PROJECT = "form_update_project",
    FORM_UPDATE_PROJECT_SUCCESS = "form_update_project_success",
    UPDATE_PROJECT = "update_project",
    UPDATE_PROJECT_SUCCESS = "update_project_success",
    ADD_PROJECT = "add_project",
    CANCEL_ADD_PROJECT = "cancel_add_project",
    ADD_PROJECT_SUCCESS = "add_project_success",
    SWITCH_ADD_PROJECT = "switch_add_project",
    SAVE_NEW_PROJECT = "save_new_project",
    SAVE_NEW_PROJECT_SUCCESS = "save_new_project_success",
    DELETE_PROJECT = "delete_project",
    DELETE_PROJECT_SUCCESS = "delete_project_success",
    PROJECT_ERROR = "project_error",

    FETCH_SKILLS = "fetch_skills",
    FETCH_SKILLS_SUCCESS = "fetch_skills_success",
    FORM_UPDATE_SKILL = "form_update_skill",
    FORM_UPDATE_SKILL_SUCCESS = "form_update_skill_success",
    UPDATE_SKILL = "update_skill",
    UPDATE_SKILL_SUCCESS = "update_skill_success",
    ADD_SKILL = "add_skill",
    CANCEL_ADD_SKILL = "cancel_add_skill",
    ADD_SKILL_SUCCESS = "add_skill_success",
    SWITCH_ADD_SKILL = "switch_add_skill",
    SAVE_NEW_SKILL = "save_new_skill",
    SAVE_NEW_SKILL_SUCCESS = "save_new_skill_success",
    DELETE_SKILL = "delete_skill",
    DELETE_SKILL_SUCCESS = "delete_skill_success",
    SKILL_ERROR = "skill_error",

    FETCH_EXPERIENCES = "fetch_experiences",
    FETCH_EXPERIENCES_SUCCESS = "fetch_experiences_success",
    FORM_UPDATE_EXPERIENCE = "form_update_experience",
    FORM_UPDATE_EXPERIENCE_SUCCESS = "form_update_experience_success",
    UPDATE_EXPERIENCE = "update_experience",
    UPDATE_EXPERIENCE_SUCCESS = "update_experience_success",
    ADD_EXPERIENCE = "add_experience",
    CANCEL_ADD_EXPERIENCE = "cancel_add_experience",
    ADD_EXPERIENCE_SUCCESS = "add_experience_success",
    SWITCH_ADD_EXPERIENCE = "switch_add_experience",
    SAVE_NEW_EXPERIENCE = "save_new_experience",
    SAVE_NEW_EXPERIENCE_SUCCESS = "save_new_experience_success",
    DELETE_EXPERIENCE = "delete_experience",
    DELETE_EXPERIENCE_SUCCESS = "delete_experience_success",
    EXPERIENCE_ERROR = "experience_error",

    USER_LOG_IN = "user_log_in",
    USER_LOG_IN_SUCCESS = "user_log_in_success",
    USER_LOG_OUT = "user_log_out",
    USER_REGISTER = "user_register",
    USER_REGISTER_SUCCESS = "user_register_success",
    USER_ERROR = "user_error",
}
